import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = theme => ({
		root: {
		// width: '200px',
		position: 'absolute',
		// left: '50%',
		// transform: 'translateX(-50%)',
		// transform: 'translateX(220px) translateY(20px)',
		bottom: '30px',
		color: 'white',
		borderRadius: '0',
		background: 'rgb(13, 34, 62)',
		'&:hover': {
			background: 'rgb(13, 34, 62)'
		},
		// vv stasou added this vv
		transition: 'all .3s'
	}
});

const CollapseButton = withStyles(styles)(Button);

export default CollapseButton;



// WEBPACK FOOTER //
// ./src/js/components/Mui/CollapseButton.js